export enum DraftStatus {
    "Draft" = "Draft",
    "Submitted" = "Submitted",
    "Changes_Requested" = "Changes Requested",
    "Approved" = "Approved",
}
